import React, { useEffect, useState } from "react";
import numberCountData from "../data/numberCountData";
import CountUp from "react-countup";
import axios from "axios";

export default function NumberCount() {
  const [stat, setStat] = useState([]);

  useEffect(() => {
    if (setStat.length < 1) {
      setStat(numberCountData);
    }

    axios
      .get("/stat")
      .then(({ data }) => {
        setStat(data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  const countElements = stat.map((stat) => {
    return (
      <div className="count" key={stat._id}>
        <h2>
          <CountUp start={0} end={stat.count} duration={10} />
        </h2>
        <p>{stat.title}</p>
      </div>
    );
  });
  return (
    <section className="count_section">
      <div className="count_container">{countElements}</div>
    </section>
  );
}
